import React,{useState} from 'react';
import MapaRecinto3D from './MapaRecinto3D';
import MapaRecinto2D from './MapaRecinto2D';
export default function MapaReservaInteractivo({plano,zonas,onZonaClick,disabled,paused=false,fallback2d,cargando=false,errorCarga=false}){
 const [vista3d,setVista3d]=useState(true);
 const props={plano,zonas,onZonaClick,disabled,paused};
 if(cargando||errorCarga)return <div className="recinto-map-loading" role="status" aria-busy={cargando&&!errorCarga}>{errorCarga?'No se pudo cargar el plano. Actualiza para volver a intentarlo.':'Cargando plano del recinto…'}</div>;
 return <>
  <div className="recinto-view-switch" role="group" aria-label="Vista del mapa"><button type="button" className="btn-secondary" aria-pressed={vista3d} onClick={()=>setVista3d(true)}>Vista 3D</button><button type="button" className="btn-secondary" aria-pressed={!vista3d} onClick={()=>setVista3d(false)}>Vista 2D</button></div>
  {vista3d?<MapaRecinto3D {...props}/>:plano?<MapaRecinto2D {...props}/>:fallback2d}
 </>;
}
